(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lotus-home-stories"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-stories-prev],[data-stories-next]');
    if (!button) return;
    const section = button.closest('[data-lotus-home-stories]');
    const track = section && section.querySelector('[data-stories-track]');
    if (!track) return;
    const card = track.querySelector('.lotus-home-stories__card');
    const distance = card ? card.getBoundingClientRect().width + 18 : track.clientWidth;
    track.scrollBy({ left: button.hasAttribute('data-stories-next') ? distance : -distance, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lotus-pdp-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const thumb = event.target.closest('[data-lotus-thumb]');
    const step = event.target.closest('[data-lotus-step]');
    if (thumb || step) {
      const gallery = (thumb || step).closest('[data-lotus-gallery]');
      const slides = Array.from(gallery.querySelectorAll('[data-lotus-slide]'));
      const thumbs = Array.from(gallery.querySelectorAll('[data-lotus-thumb]'));
      if (!slides.length) return;
      const active = Math.max(0, slides.findIndex(slide => !slide.hidden));
      const next = thumb ? Number(thumb.dataset.lotusThumb) : (active + Number(step.dataset.lotusStep) + slides.length) % slides.length;
      slides.forEach((slide, index) => { slide.hidden = index !== next; });
      thumbs.forEach((button, index) => { button.classList.toggle('is-active', index === next); button.setAttribute('aria-pressed', String(index === next)); });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lotus-pdp-reviews"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initialize(section) {
      section.querySelectorAll('[data-lotus-review-row]').forEach(function(row, index) {
        const track = row.querySelector('[data-lotus-review-track]');
        const original = row.querySelector('[data-lotus-review-original]');
        if (!track || !original) return;
        const width = original.getBoundingClientRect().width;
        if (!width) return;
        let copies = 0;
        while (track.scrollWidth < row.clientWidth + width && copies < 40) {
          const clone = original.cloneNode(true);
          clone.removeAttribute('data-lotus-review-original');
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('inert', '');
          clone.querySelectorAll('[data-shopify-editor-block]').forEach(function(tile) { tile.removeAttribute('data-shopify-editor-block'); });
          track.appendChild(clone);
          copies += 1;
        }
        track.style.setProperty('--lotus-reviews-travel', width + 'px');
        track.style.setProperty('--lotus-reviews-duration', Math.max(8, width / [32, 38, 35][index % 3]) + 's');
        track.classList.add('is-ready');
      });
      const toggle = section.querySelector('[data-lotus-reviews-toggle]');
      if (toggle && !toggle.dataset.lotusBound) {
        toggle.dataset.lotusBound = 'true';
        toggle.addEventListener('click', function() {
          const paused = section.classList.toggle('is-paused');
          toggle.textContent = paused ? '▶' : 'Ⅱ';
          toggle.setAttribute('aria-label', paused ? 'Play photo slider' : 'Pause photo slider');
        });
      }
    }
    function initializeAll() {
      document.querySelectorAll('[data-lotus-reviews]').forEach(initialize);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    let resizeTimer;
    window.addEventListener('resize', function() { clearTimeout(resizeTimer); resizeTimer = setTimeout(initializeAll, 150); });
    document.addEventListener('shopify:section:load', function(event) {
      event.target.querySelectorAll('[data-lotus-reviews]').forEach(initialize);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
